var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-modal',{attrs:{"show":_vm.show},on:{"hide":_vm.hideModal}},[_c('client-link-branch',{on:{"hide":_vm.hideModal,"branch-linked":_vm.handleBranchLinked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }